/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import "./manageSubtopic.scss";
import "../Manage-Topics/manageTopic.scss";
import Switch from "react-switch";
import Modal from "react-bootstrap/Modal";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    savedSubTopic,
    editedSubTopic,
    getSubTopics,
    //   showSideBar,
    //   hideSideBar,
    changeSubtopicStatus,
    reorderSubTopics,
    reorderedSubTopics,
    resetResourceLoading
} from "../../../../ActionCreators/AdminAction/manageSkillpathAction";
import { clearErrors } from "../../../../ActionCreators/errorAction";
import Snackbar from '@mui/material/Snackbar';
import { BallBeat, TopicLoader } from '../../../../Loader/loader';
import EllipsisText from "react-ellipsis-text";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

class ManageSubTopic extends Component {
    constructor(props, context) {
        super(props);

        this.state = {
            checked: false,
            isAddTopic: false,
            name: "",
            rows: [],
            selectedIds: [],
            APIcall: [],
            imageUrl: "/images/empty-image.svg",
            show: false,
            chars_left: 75,
            maxChar: 75,
        };
    }
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        // this.props.hideSideBar();
        this.setState({
            skillPathId: this.props.history.location.state.skillPathId,
            clone: this.props.history.location.state.clone,
            topicId: this.props.history.location.state.id,
            title: this.props.history.location.state.title,
        }, () => {
            this.props.getSubTopics(this.state.topicId);
        })
    }
    handleChange = (id, checked) => {
        this.setState({
            checked: !checked
        }, () => {
            this.props.changeSubtopicStatus(id, this.state.skillPathId, this.state.topicId, checked)
        })
    }

    addSubTopic = (el, val) => {
        if (el !== null) {
            this.setState({
                name: el.title,
                chars_left: this.state.maxChar - el.title.length,
                id: el._id
            })
        }

        this.setState({
            edit: val,
            isAddSubTopic: true,
        })
    }
    handleModal = () => {
        this.setState({
            isAddSubTopic: false,
            name: '',
            nameError: '',
            maxChar: 75,
            chars_left: 75
        })
    }

    changeName = (val) => {
        const charCount = val.length;
        const maxChar = 50;
        const charLength = maxChar - charCount;
        this.setState({
            name: val,
            nameError: '',
            chars_left: charLength
        })
    }


    backtoBubble = () => {
        this.props.history.goBack();
        // this.props.showSideBar();
    };



    saveSubTopic = async () => {
        if (this.state.name === "") {
            this.setState({
                nameError: "Please enter Subunit",
            });
        } else {
            let obj = {
                title: this.state.name,
                topic_id: this.state.topicId,
            };
            await this.props.savedSubTopic(obj);
            await this.props.getSubTopics(this.state.topicId);
            this.setState({
                isAddSubTopic: false,
                name: "",
            });
        }
    };

    editSubTopic = async () => {
        if (this.state.name === "") {
            this.setState({
                nameError: "Please enter Subunit",
            });
        } else {
            let obj = {
                title: this.state.name,
                b_id: this.state.topicId,
                _id: this.state.id
            };
            await this.props.editedSubTopic(obj);
            await this.props.getSubTopics(this.state.topicId);
            this.setState({
                isAddSubTopic: false,
                name: "",
            });
        }
    }
    snackClosed = () => {
        this.props.clearErrors();
    };


    goToSubTopicsContent = async (id, b_id, title) => {
        this.setState({
            subtopicId: id,
            title: title
        })
        this.props.history.push({
            pathname: '/manage-skillpath/subtopic/add-content',
            state: { id: id, title: title, skill: this.props.history.location.state.skill, skillId: this.props.history.location.state.skillId, topicId: b_id || this.state.topicId, skillPathId: this.state.skillPathId, clone: this.state.clone }
        })
        // await this.props.hideSideBar()
        await this.props.resetResourceLoading()
    }

    closePopover = () => {
        this.setState({
            show: false,
        });
    };
    backToSubject = () => {
        this.props.history.goBack();
        this.props.history.goBack();
    };



    goToSubTopics = async (items) => {
        // this.setState({
        //     title: items.title,
        //     topicId: items._id
        // }, () => {
        //     this.props.getTopicObject(this.props.history.location.state.sId, this.state.topicId)
        // })
        // this.props.getSubTopics(items._id)
        // this.props.hideSideBar()
    }



    handleDragEnd = async (result) => {
        if (!result.destination) return
        await this.props.reorderSubTopics(result)
        await this.props.reorderedSubTopics(this.state.topicId, this.props.subTopics.map(el => [{ _id: el._id, index: el.index }][0]))
    }
    render() {
        const { subTopics, isSubTopicLoading, subTopicDetail, theme, successEnable, successMessage, successMessageText } = this.props
        const { edit } = this.state
        return (
            <div className='subtopics-module'>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                {/* <div className='collapse-topics' style={{ background: '#fff' }} >
                    <h1>{this.props.history.location.state.subject}</h1>
                    <div id="accordion" className="accordion">
                        {
                            topicsListOfSubject !== undefined && topicsListOfSubject.map((items, index) => {

                                return (
                                    <div className="card mb-0" >
                                        <div className={items.sub_topics.length === 0 ? 'card-header collapsed display' : 'card-header collapsed'} data-toggle="collapse" href={`#${index}`}>
                                            <a className="card-title" onClick={() => this.goToSubTopics(items)}>
                                                <div style={{ marginLeft: 30 }} className='d-flex justify-content-start align-items-center'>
                                                    <p>{items.title !== null && <EllipsisText text={items.title} length={"25"} />}</p>
                                                </div>
                                            </a>
                                        </div>
                                        <div id={index} className={this.state.topicId === items._id ? 'card-body collapse show' : 'card-body collapse'} data-parent={`#accordion`} >
                                            <ul className='content-holder' >
                                                {
                                                    items.sub_topics.sort((a, b) => (a.index > b.index) ? 1 : -1).map((el, i) => {
                                                        return (
                                                            <li key={i} className="resource " style={{ background: this.state.title === el.title ? '#EDF3F3' : '' }}>
                                                                <div className="col-md-12 col-8 recent-title" >
                                                                    <div onClick={() => this.goToSubTopicsContent(items._id, el.title)} >
                                                                        <h1>{el.title !== null && <EllipsisText text={el.title} length={"120"} />}
                                                                        </h1>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>

                                    </div>


                                )
                            })
                        }
                    </div>
                </div> */}
                <div className='manage-subjects' >
                    <div className='d-flex' style={{ fontSize: 20, cursor: 'pointer' }}>
                        <p style={{ marginTop: 5 }} onClick={() => this.backtoBubble()}>
                            <img src='/images/back1.svg' alt='' width={24} />
                        </p>&nbsp;&nbsp;
                        <h1>{this.state.title}</h1>
                    </div>

                    {subTopicDetail !== undefined &&
                        <div className='upper-details'>
                            <div>
                                <img src={subTopicDetail.image} alt='' width='176px' height='120px' />
                            </div>

                            <Fragment>
                                <div className='content-count'>
                                    {<img src='/images/topic-icon.svg' alt='' />}
                                    <p>{subTopicDetail.subtopics}</p>
                                    <span>Subtopics</span>
                                </div>
                                <div className='content-count'>
                                    {<img src='/images/article-icon.svg' alt='' />}
                                    <p>{subTopicDetail.articles}</p>
                                    <span>Articles</span>
                                </div>
                                <div className='content-count'>
                                    {<img src='/images/video-icon.svg' alt='' />}
                                    <p>{subTopicDetail.videos}</p>
                                    <span>Videos</span>
                                </div>
                                <div className='content-count'>
                                    {<img src='/images/quiz-icon.svg' alt='' />}
                                    <p>{subTopicDetail.quizzes}</p>
                                    <span>Quizes</span>
                                </div>
                                <div className='content-count'>
                                    {<img src='/images/document-icon.svg' alt='' />}
                                    <p>{subTopicDetail.documents}</p>
                                    <span>Documents</span>
                                </div>
                            </Fragment>

                        </div>
                    }
                    <div className='subject-header'>
                        {this.state.clone ? null : <button onClick={() => this.addSubTopic(null, false)}><img src='/images/plus-white.svg' alt='' /> &nbsp; Add Subtopic</button>}
                        <div className="animated-search d-none" >
                            <input id="express-form-typeahead" autocomplete="off" spellcheck="false" type="text" />
                            <div className="symbol" >
                                <img src='/images/search1.svg' alt='' />
                            </div>
                        </div>
                        <div className='content-heading'>
                            <ul>
                                <li>
                                    <div>No.</div>
                                    <div style={{ width: '29%' }}>Subtopic</div>
                                    <div>Videos</div>
                                    <div>Documents</div>
                                    <div>Articles</div>
                                    <div>Quizzes</div>
                                    <div>Status</div>
                                    <div>Actions</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {
                        <DragDropContext onDragEnd={this.handleDragEnd}>
                            <Droppable droppableId={this.state.topicId}>
                                {
                                    (provided) => (
                                        <ul className='subject-list' {...provided.droppableProps} ref={provided.innerRef} >
                                            {isSubTopicLoading ?
                                                <div>
                                                    <TopicLoader />
                                                </div> :
                                                subTopics !== undefined && subTopics.length > 0 ?
                                                    subTopics.map((el, index) => {
                                                        return (
                                                            <Draggable key={el?._id} draggableId={el?._id} index={index} >
                                                                {
                                                                    (provided) => (
                                                                        <li {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} onClick={() => this.goToSubTopicsContent(el._id, el.b_id, el.title)}>
                                                                            <div className='subject-num d-flex' onClick={(e) => {
                                                                                e.preventDefault()
                                                                                e.stopPropagation()
                                                                            }} >
                                                                                <img src='/images/drag.svg' alt='' />
                                                                                {/* <OverlayTrigger
                                                                                    placement='right'
                                                                                    show={this.state.show}
                                                                                    rootClose={true}
                                                                                    trigger='click'
                                                                                    overlay={
                                                                                        <Popover id={'popover-contained1'} style={{ width: '246px', borderRadius: 2, zIndex: 3, border: 'none', boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)' }}>
                                                                                            <DragTooltip closePopover={this.closePopover} />
                                                                                        </Popover>
                                                                                    }> */}
                                                                                <p>{index + 1}</p>
                                                                                {/* </OverlayTrigger> */}
                                                                            </div>
                                                                            <div className='subject-name ml-0' style={{ width: '34%' }}>
                                                                                <p style={{ width: '100%' }}>
                                                                                    {el?.title && <EllipsisText text={el?.title} length={55} />}
                                                                                    {/* {el.title} */}
                                                                                </p>
                                                                            </div>
                                                                            <div className='text-center' >
                                                                                <h3>{el.videos}</h3>
                                                                            </div>
                                                                            <div className='text-center'>
                                                                                <h3>{el.documents}</h3>
                                                                            </div>
                                                                            <div className='text-center' >
                                                                                <h3>{el.articles}</h3>
                                                                            </div>
                                                                            <div className='text-center'>
                                                                                <h3>{el.quizzes}</h3>
                                                                            </div>

                                                                            <div className='text-center'>
                                                                                <p onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    this.handleChange(el._id, el.active)
                                                                                }}> <Switch
                                                                                        width={30}
                                                                                        height={16}
                                                                                        uncheckedIcon={false}
                                                                                        checkedIcon={false}
                                                                                        onColor='#00B24B'
                                                                                        checked={el.active} /><br />
                                                                                    {el.active ? 'Active' : 'Inactive'}
                                                                                </p>
                                                                            </div>
                                                                            <div className='text-center'>
                                                                                <img src='/images/edit-pencil.svg' alt='' onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation()
                                                                                    this.addSubTopic(el, true)
                                                                                }} /> &nbsp;&nbsp;
                                                                                {/* <img src='/images/delete.svg' alt='' />&nbsp;&nbsp; */}
                                                                                {/* <img src='/images/menu.svg' alt='' /> */}
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                            </Draggable>
                                                        )
                                                    })
                                                    : <div className='empty-list'>
                                                        <img src='/images/empty.png' alt='' />
                                                        <p>You have not added any topics  yet.</p>
                                                    </div>

                                            }
                                        </ul>
                                    )}
                            </Droppable>
                        </DragDropContext>
                    }
                </div>
                <Modal
                    show={this.state.isAddSubTopic}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"add-topic-modal"}
                >
                    <div className="modal-header" style={{ background: theme?.bgColor }}>
                        <h5 className="modal-title">{edit ? 'Edit Subtopic' : 'Add Subtopic'} <br /><p>{this.state.title}</p> </h5>

                        <div className="sticky-close" onClick={this.handleModal}>
                            <img src="/images/close-white.svg" width='15px' alt='' /></div>

                    </div>
                    <Modal.Body style={{ padding: '22px 40px 22px 40px', }}>
                        <div>
                            <label>Subtopic Name*
                                <aside className='float-right'>{this.state.chars_left}</aside>
                            </label>
                            <input className='form-control mt-2 text-capitalize' value={this.state.name} maxLength={this.state.maxChar} onChange={(e) => this.changeName(e.target.value)} />
                        </div>
                        <small>{this.state.nameError}</small>
                        <div className='save-btn'>
                            {
                                edit ?
                                    <button onClick={this.editSubTopic} style={{ backgroundColor: theme?.bgColor }} >
                                        {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : 'Save'}</button>
                                    :
                                    <button onClick={this.saveSubTopic} style={{ backgroundColor: theme?.bgColor }}>
                                        {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : 'Save'}</button>
                            }&nbsp;&nbsp;
                            <button onClick={this.handleModal}>Cancel</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { subTopics, isSubTopicLoading } = state.manageSkillpath
    const { theme } = state.account
    const { successMessageText, successMessage, successEnable } = state.error
    return {
        subTopics, isSubTopicLoading, theme,
        // subject_id, topicsListOfSubject, isSubTopicLoading, subTopicDetail, 
        successMessageText, successMessage, successEnable
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getSubTopics, savedSubTopic, editedSubTopic,
        // showSideBar, hideSideBar, 
        reorderSubTopics, changeSubtopicStatus, reorderedSubTopics, resetResourceLoading,
        // getTopicListOfSubject,resetResourceLoading, getTopicObject, 
        clearErrors
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageSubTopic));
